export default "__VITE_ASSET__9ed4db95__"